import { Clipboard } from '@capacitor/clipboard'

/**
 * Универсальная функция копирования текста в буфер обмена
 * Работает как в браузере, так и в мобильных приложениях (Capacitor)
 * @param {string} text - Текст для копирования
 * @returns {Promise<void>}
 */
export async function copyToClipboard(text) {
  try {
    // Используем Capacitor Clipboard API (работает везде - в браузере и в приложениях)
    await Clipboard.write({
      string: text
    })
  } catch (error) {
    // Fallback на стандартный API, если Capacitor не доступен
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text)
    } else {
      // Старый метод для совместимости
      const textArea = document.createElement('textarea')
      textArea.value = text
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
      } finally {
        document.body.removeChild(textArea)
      }
    }
  }
}

/**
 * Получить текст из буфера обмена
 * @returns {Promise<string>}
 */
export async function readFromClipboard() {
  try {
    const result = await Clipboard.read()
    return result.value
  } catch (error) {
    // Fallback на стандартный API
    if (navigator.clipboard && navigator.clipboard.readText) {
      return await navigator.clipboard.readText()
    }
    return ''
  }
}

